import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Button, Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-regular-svg-icons';

let dialogStyles = {
    width: '500px',
    maxWidth: '100%',
    margin: '0 auto',
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    zindex: '999',
    backgroundColor: '#fff',
    padding: '10px 20px 40px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 0 40px 20px rgba(0,0,0,0.26)'
};

let dialogCloseButtonStyles = {
    marginBottom: '15px',
    padding: '3px 8px',
    cursor: 'pointer',
    borderRadius: '50%',
    border: 'none',
    width: '30px',
    height: '30px',
    fontWeight: 'bold',
    alignSelf: 'flex-end'
}



function CancelDialog(props) {
    const [remark, setRemark] = useState('');
    const [isCheckedDeclaration, setIsCheckedDeclaration] = useState(false);
    const [showError, setShowError] = useState("");
    useEffect(() => {
        setShowError(false);
        setRemark("");
        setIsCheckedDeclaration(false);
    }, []);

    const handleRemark = (val) => {
        const trimVal = val;
        setRemark(trimVal);
        // props.setCancelRemark(remark);
    }
    const yesHandler = () => {
        if ((props?.billDetails?.type === "SI" || props?.billDetails?.type === "SP" || props?.billDetails?.type === "PP") && props?.billDetails?.isirn === "1" && !isCheckedDeclaration) {
            setShowError(true);
            return;
        }
        props.onYes(remark);
    }

    let dialog = (
        <div style={dialogStyles}>
            <button style={dialogCloseButtonStyles} onClick={props.onNo}><FontAwesomeIcon icon={faWindowClose} /></button>
            <div className="text-danger">
                {parse(props.children)}
            </div>
            <div className='my-3'>
                <Form.Group >
                    <Form.Label>Cancel Remark<span className="text-danger">*</span></Form.Label>
                    <Form.Control type="text" placeholder="Cancel Remark" maxLength={500}
                        value={remark}
                        onChange={(e) => handleRemark(e.target.value)}
                        autoComplete="off"
                        required />
                </Form.Group>
            </div>
            {
                (props?.billDetails?.type === "SI" || props?.billDetails?.type === "SP" || props?.billDetails?.type === "PP") && props?.billDetails?.isirn === "1" ?
                    <div>
                        {showError &&
                            <div style={{ color: 'red', marginTop: '5px', fontSize: "12px" }}>
                                You must agree before proceeding.
                            </div>
                        }
                        <Form.Check
                            checked={isCheckedDeclaration}
                            style={{ fontSize: "14px" }}
                            type='checkbox'
                            label="I confirm that IRN has been deleted from portal and transaction should be cancelled."
                            onChange={(e) => setIsCheckedDeclaration(e.target.checked)}
                        />
                    </div> : null
            }
            <br></br>
            <div style={{ "textAlign": "center" }}>
                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={yesHandler} disabled={!remark} >Yes</Button>&nbsp;&nbsp;
                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={props.onNo}  >No</Button>&nbsp;&nbsp;
            </div>
        </div>
    );

    if (!props.isOpen) {
        dialog = null;
    }


    return (
        <div>
            {dialog}
        </div>
    );
}

export default CancelDialog;